import React from 'react';

export default function MarkerPin2Icon({ color }: { color?: string }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 2C8.13 2 5 5.13 5 9c0 3.2 2.2 6.8 5.5 9.5 0.4 0.3 0.8 0.6 1.5 0.6s1.1-0.3 1.5-0.6c3.3-2.7 5.5-6.3 5.5-9.5 0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
        stroke={color || 'currentColor'}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
}
